// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Zi3pm","twoButtons":"styles_twoButtons__mDDb4"};